import { gql } from "@apollo/client";

export const PROCESS_CONFIG = gql`
  query processConfig($where: ProcessConfigWhereInput!) {
    processConfig(where: $where) {
      id
      type
      value
    }
  }
`;

export const PROCESS_CONFIGS = gql`
  query processConfigs($where: ProcessConfigWhereInput!) {
    processConfigs(where: $where) {
      data {
        id
        type
        value
      }
      count
    }
  }
`;

const processConfigQueries = { PROCESS_CONFIG, PROCESS_CONFIGS };

export default processConfigQueries;
